exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-item-7981__container .custom-dropdown-menu{right:0;left:auto;grid-template-columns:repeat(5,minmax(0,1fr));width:768px;max-width:none!important}.menu-item-7981__container .custom-dropdown-menu a{display:flex}.menu-item-7981__container .custom-dropdown-menu img{margin-right:.375rem;width:1.25rem}", ""]);

// exports
